//@ts-nocheck
import { useQuery } from 'react-query';
import qs from 'qs';

import { axios } from 'lib/axios';

const defaultQueryParams = {
  page: 0,
  limit: 6,
  search: '',
  queryKey: ['blogs'],
  queryOptions: {},
};

const getAll = async (queryStringParams) => {
  try {
    const queryString = qs.stringify({ ...queryStringParams });
    const { data } = await axios.get(`/website/blogs?${queryString}`);

    return data;
  } catch (error) {
    console.log(error);
  }

  return { data: [], total: 0};

};

export const useGetAllBlogs = (queryParams = {}) => {
  const { queryKey, queryOptions, page, limit, search } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  const queryStringParams = {
    limit,
    search,
    offset: page * limit,
  };

  return useQuery([...queryKey, search], () => getAll(queryStringParams), {
    select: ({ data: blogs, total }) => ({ blogs, total }),
    initialData: {
      blogs: [],
      total: 0,
    },
    ...queryOptions,
  });
};
